<template>
  <a-modal
    :title="null"
    :visible="!!subsModalStatus"
    wrapClassName="demo__SubsModal--con"
    :dialogClass="subsInfo ? 'demo__SubsModal info' : 'demo__SubsModal'"
    @cancel="closeModal"
    :footer="null"
    :mask="false"
  >
    <Subscriptions v-show="!subsInfo" />
    <SubModalInfo :subs-info="subsInfo" v-if="subsInfo" />
    <i class="demo__SubsModal--close fa-light fa-xmark" @click="closeModal"></i>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";

import Subscriptions from "Components/Subscriptions";
import SubModalInfo from "./components/SubModalInfo";

export default {
  components: {
    Subscriptions,
    SubModalInfo,
  },
  data() {
    return {
      subsInfo: undefined,
    };
  },
  computed: {
    ...mapGetters(["subsModalStatus"]),
  },
  watch: {
    subsModalStatus(val) {
      if (!val) {
        setTimeout(() => {
          this.subsInfo = undefined;
        }, 300);
      }
    },
  },
  beforeDestroy() {
    this.$root.$off("updateSubsModalInfo", this.updateSubsModalInfo);
  },
  created() {
    this.$root.$on("updateSubsModalInfo", this.updateSubsModalInfo);
    this.$accessModule("modalsub", this);
  },
  methods: {
    updateSubsModalInfo(info) {
      if (!info?.currentField) {
        this.subsInfo = info;
      } else {
        this.subsInfo[info.currentField] = info.currentValue;
      }

      if (info && !this.subsModalStatus) {
        this.$store.dispatch("updateSubsModalStatus", true);
      }
    },
    closeModal() {
      this.$store.dispatch("updateSubsModalStatus", false);
      this.$nextTick(() => {
        setTimeout(() => {
          this.$root.$emit("updateSubsModalInfo", undefined);
        }, 300);
      });
    },
  },
};
</script>
